import { render } from "./questionTwo.vue?vue&type=template&id=1c872f1c"
import script from "./questionTwo.vue?vue&type=script&lang=js"
export * from "./questionTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__